export default __webpack_public_path__ + "static/media/NeueMontreal-Medium.15b1070b.otf";